(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-cc-colgrid]');
    if (!section || section.dataset.filterBound === '1') return;
    section.dataset.filterBound = '1';

    var pill  = section.querySelector('[data-cc-filter-open]');
    var panel = section.querySelector('[data-cc-filter]');
    var close = section.querySelector('[data-cc-filter-close]');
    var scrim = section.querySelector('[data-cc-filter-scrim]');

    if (!pill || !panel) return;

    function openFilter() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeFilter() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    pill.addEventListener('click', openFilter);
    if (close) close.addEventListener('click', closeFilter);
    if (scrim) scrim.addEventListener('click', closeFilter);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closeFilter();
    });

    /* Sort options — reload page with ?sort_by= */
    var sortBtns = section.querySelectorAll('[data-sort]');
    sortBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sort = btn.dataset.sort;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort);
        window.location.href = url.toString();
      });
    });

    /* Tag filters — Shopify tag-based collection filtering */
    var tagBtns = section.querySelectorAll('[data-tag]');
    tagBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.dataset.tag;
        var base = window.location.pathname.replace(/\/[^\/]*$/, '');
        if (window.location.pathname.match(/\/collections\/[^\/]+$/)) {
          base = window.location.pathname;
        }
        if (btn.classList.contains('is-active')) {
          window.location.href = base;
        } else {
          window.location.href = base + '/' + encodeURIComponent(tag);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craft-techpack"]) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-cc-lab-track]');
    var hint = document.querySelector('.cc-lab__scroll-hint');
    if (!track || !hint) return;
    var hidden = false;
    track.addEventListener('scroll', function () {
      if (!hidden && track.scrollLeft > 60) {
        hint.style.transition = 'opacity 0.4s ease';
        hint.style.opacity = '0';
        hidden = true;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ──────────────────────────────────────────
     Header mega-nav + announcement controller
     Idempotent — safe to rerun (SPA transitions).
     ────────────────────────────────────────── */
  (function () {
    var header = document.querySelector('[data-cc-header]');
    if (!header || header.dataset.megaBound === '1') return;
    header.dataset.megaBound = '1';

    /* ── References ── */
    var burger   = header.querySelector('[data-cc-burger]');
    /* Drawer and search live OUTSIDE the header element now (sibling of
       <header>) — they were moved out to escape the header's transform
       containing block. So scope these lookups to the document. */
    var drawer   = document.querySelector('[data-cc-drawer]');
    var triggers = header.querySelectorAll('[data-mega-trigger]');
    var panels   = header.querySelectorAll('[data-mega-panel]');
    var scrim    = header.querySelector('[data-mega-scrim]');
    var promo    = document.querySelector('[data-cc-promo]');

    var hoverTimer   = null;
    var restoreTimer = null;
    var activeId     = null;

    /* ── Header + promo offset (set CSS vars so hero etc can align) ── */
    var barEl = header.querySelector('.cc-header__bar');
    var headerH = barEl ? barEl.offsetHeight : 60;
    var root = document.documentElement;
    root.style.setProperty('--header-h', headerH + 'px');

    function setOffsets(promoH) {
      root.style.setProperty('--announce-offset', promoH + 'px');
      root.style.setProperty('--header-total', (promoH + headerH) + 'px');
    }

    if (promo) {
      var pH = promo.offsetHeight;
      setOffsets(pH);
      /* Hide promo when scrolling past it, show on return to top */
      window.addEventListener('scroll', function () {
        if (window.scrollY > pH + 20) {
          promo.classList.add('is-hidden');
          setOffsets(0);
        } else {
          promo.classList.remove('is-hidden');
          setOffsets(pH);
        }
      }, { passive: true });
    } else {
      setOffsets(0);
    }

    /* ── Auto-hide on scroll-down + transparent-on-hero (homepage only) ── */
    var lastY = window.scrollY || 0;
    var ticking = false;
    var HIDE_THRESHOLD = headerH + 40;

    function updateHeaderOnScroll() {
      var y = window.scrollY || 0;
      var hero = document.querySelector('[data-cc-hero]');
      var isHomepage = document.body.classList.contains('template-index');

      /* Transparent-over-hero state — only on homepage, only while hero is in view */
      if (isHomepage && hero) {
        var heroRect = hero.getBoundingClientRect();
        /* Navbar bottom (y + headerH) needs to be above the hero bottom in
           viewport coords. Use bounding rect so it's robust to negative
           margins / absolute layouts. */
        if (heroRect.bottom > headerH * 0.6) {
          header.classList.add('is-on-hero');
        } else {
          header.classList.remove('is-on-hero');
        }
      } else {
        header.classList.remove('is-on-hero');
      }

      /* Auto-hide direction logic */
      if (y < HIDE_THRESHOLD) {
        header.classList.remove('is-hidden');
      } else if (y > lastY + 4) {
        header.classList.add('is-hidden');
      } else if (y < lastY - 4) {
        header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateHeaderOnScroll);
        ticking = true;
      }
    }, { passive: true });

    /* Run twice — once immediately, once after layout settles (images, fonts) */
    updateHeaderOnScroll();
    window.addEventListener('load', updateHeaderOnScroll);
    setTimeout(updateHeaderOnScroll, 50);
    setTimeout(updateHeaderOnScroll, 250);

    /* ── Mega hover controller ── */
    function openMega(id) {
      clearTimeout(hoverTimer);
      clearTimeout(restoreTimer);

      if (activeId === id) return;

      panels.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      triggers.forEach(function (t) {
        t.classList.remove('is-active');
        var btn = t.querySelector('.cc-header__link--trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      var panel   = header.querySelector('[data-mega-panel="' + id + '"]');
      var trigger = header.querySelector('[data-mega-trigger="' + id + '"]');

      if (panel) {
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
      }
      if (trigger) {
        trigger.classList.add('is-active');
        var btn = trigger.querySelector('.cc-header__link--trigger');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }
      header.classList.add('is-mega-open');
      if (scrim) scrim.classList.add('is-visible');
      activeId = id;
    }

    function startClose() {
      hoverTimer = setTimeout(function () { closeMega(); }, 220);
    }
    function cancelClose() {
      clearTimeout(hoverTimer);
    }

    function closeMega() {
      panels.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      triggers.forEach(function (t) {
        t.classList.remove('is-active');
        var btn = t.querySelector('.cc-header__link--trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (scrim) scrim.classList.remove('is-visible');
      activeId = null;

      /* Delay mix-blend restore so slide-up finishes first */
      restoreTimer = setTimeout(function () {
        if (!activeId) header.classList.remove('is-mega-open');
      }, 420);
    }

    triggers.forEach(function (t) {
      t.addEventListener('mouseenter', function () {
        openMega(t.dataset.megaTrigger);
      });
      t.addEventListener('mouseleave', startClose);
    });

    panels.forEach(function (p) {
      p.addEventListener('mouseenter', cancelClose);
      p.addEventListener('mouseleave', startClose);
    });

    if (scrim) {
      scrim.addEventListener('click', function () {
        clearTimeout(hoverTimer);
        closeMega();
      });
    }

    /* Close when hovering over non-mega items */
    header.querySelectorAll('.cc-header__link:not(.cc-header__link--trigger)').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        closeMega();
      });
    });

    /* Close on Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeId) closeMega();
    });

    /* ── Mobile burger + drawer ── */
    if (burger && drawer) {
      function closeDrawer() {
        burger.setAttribute('aria-expanded', 'false');
        burger.classList.remove('is-open');
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        header.classList.remove('cc-header--drawer-open');
        document.body.style.overflow = '';
      }
      function openDrawer() {
        burger.setAttribute('aria-expanded', 'true');
        burger.classList.add('is-open');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        header.classList.add('cc-header--drawer-open');
        /* Make sure auto-hide doesn't pull the navbar away while drawer is open */
        header.classList.remove('is-hidden');
        document.body.style.overflow = 'hidden';
      }
      burger.addEventListener('click', function () {
        burger.getAttribute('aria-expanded') === 'true' ? closeDrawer() : openDrawer();
      });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
    }

    /* ── Mobile accordion ── */
    document.querySelectorAll('[data-drawer-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('[data-drawer-accordion]');
        if (!parent) return;
        var isOpen = parent.classList.contains('is-open');
        /* Close all */
        document.querySelectorAll('[data-drawer-accordion]').forEach(function (a) {
          a.classList.remove('is-open');
          a.querySelector('[data-drawer-trigger]').setAttribute('aria-expanded', 'false');
        });
        /* Toggle target */
        if (!isOpen) {
          parent.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ── Search drawer — open/close + predictive search ── */
    var searchEl     = document.querySelector('[data-cc-search]');
    var searchOpeners = document.querySelectorAll('[data-cc-search-open]');
    var searchClose  = document.querySelector('[data-cc-search-close]');
    var searchScrim = searchEl ? searchEl.querySelector('[data-cc-search-scrim]') : null;
    var searchInput = searchEl ? searchEl.querySelector('[data-cc-search-input]') : null;
    var searchResults = searchEl ? searchEl.querySelector('[data-cc-search-results]') : null;
    var searchSuggest = searchEl ? searchEl.querySelector('[data-cc-search-suggest]') : null;

    if (searchEl) {
      function openSearch() {
        searchEl.classList.add('is-open');
        searchEl.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (searchInput) {
          setTimeout(function () { searchInput.focus(); }, 100);
        }
      }
      function closeSearch() {
        searchEl.classList.remove('is-open');
        searchEl.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (searchInput) {
          searchInput.value = '';
        }
        if (searchResults) searchResults.innerHTML = '';
        if (searchSuggest) searchSuggest.style.display = '';
      }

      searchOpeners.forEach(function (btn) {
        btn.addEventListener('click', function () {
          /* If opened from inside the mobile drawer, close the drawer first */
          if (drawer && drawer.classList.contains('is-open') && burger) {
            burger.click();
          }
          openSearch();
        });
      });
      if (searchClose) searchClose.addEventListener('click', closeSearch);
      if (searchScrim) searchScrim.addEventListener('click', closeSearch);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchEl.classList.contains('is-open')) {
          closeSearch();
        }
      });

      /* Debounced predictive search */
      var searchTimer = null;
      function predictiveSearch(q) {
        if (!q || q.length < 2) {
          if (searchResults) searchResults.innerHTML = '';
          if (searchSuggest) searchSuggest.style.display = '';
          return;
        }
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources && data.resources.results && data.resources.results.products
              ? data.resources.results.products : [];
            renderResults(products, q);
          })
          .catch(function () {});
      }

      function renderResults(products, q) {
        if (!searchResults) return;
        if (products.length === 0) {
          searchResults.innerHTML = '<p class="cc-search__empty">No results for "' + q.replace(/</g, '&lt;') + '"</p>';
          if (searchSuggest) searchSuggest.style.display = 'none';
          return;
        }
        if (searchSuggest) searchSuggest.style.display = 'none';
        var html = '<h4 class="cc-search__results-label">Products</h4>';
        products.forEach(function (p) {
          var img = p.image || '';
          var price = p.price;
          if (typeof price === 'string' && price.indexOf('.') === -1) {
            price = (parseInt(price, 10) / 100).toFixed(2);
          }
          var title = p.title || '';
          var titleParts = title.split(/\s[—–-]\s/);
          var mainTitle = titleParts[0];
          html += '<a href="' + p.url + '" class="cc-search__result">';
          if (img) html += '<img src="' + img + '" alt="" class="cc-search__result-img" loading="lazy">';
          html += '<div class="cc-search__result-info">';
          html += '<span class="cc-search__result-title">' + mainTitle + '</span>';
          html += '<span class="cc-search__result-price">₹' + price + '</span>';
          html += '</div></a>';
        });
        html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="cc-search__view-all">View all results →</a>';
        searchResults.innerHTML = html;
      }

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          clearTimeout(searchTimer);
          var val = searchInput.value.trim();
          searchTimer = setTimeout(function () { predictiveSearch(val); }, 280);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
